<template>
    <div id="reviews-details">
        <div v-for="(deviceReview, index) in deviceReviews" :key="'review-' + index">
            <div class="row">
                <div class="col-4 col-md-3 col-lg-2 small fw-bold ellipsis">
                    {{ deviceReview.name }}
                </div>
                <div class="col-5 d-md-none small">
                    <template v-if="deviceReview.verified">
                        <span>{{ verified }}</span>
                        <span
                            class="icon icon-Orange-Trust-Badge text-primary trust-badge"
                            aria-hidden="true"
                        />
                    </template>
                </div>
                <div class="col-3 d-md-none small">
                    {{ deviceReview.date }}
                </div>
                <div class="col-12 col-md-9 col-lg-10 pb-1 pb-md-0">
                    <ob1-rating
                        v-if="deviceReview.rating"
                        :average="deviceReview.rating"
                        :rating-results-height="1.25"
                        :with-score="true"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-3 col-lg-2 d-none d-md-block small py-0">
                    <template v-if="deviceReview.verified">
                        <span>{{ verified }}</span>
                        <span class="icon icon-Orange-Trust-Badge text-primary trust-badge" aria-hidden="true" />
                    </template>
                </div>
                <div class="col-12 col-md-9 col-lg-10 fw-bold">
                    {{ deviceReview.title }}
                </div>
            </div>
            <div class="row">
                <div class="col-3 col-lg-2 d-none d-md-block small">
                    {{ deviceReview.date }}
                </div>
                <p class="col-12 col-md-9 col-lg-10 text-mw">
                    {{ deviceReview.description }}
                </p>
            </div>
            <p v-if="deviceReview.originallyPublished" v-html="deviceReview.originallyPublished" />
            <div v-if="index !== deviceReviews.length - 1" class="col-12 px-0">
                <ob1-separateur class="mb-1 mb-md-2" />
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "ReviewsDetails",
    props: {
        deviceReviews: {
            type: Array,
            required: true
        },
        reviewsTotalNumber: {
            type: Number,
            required: true
        },
        verified: {
            type: String,
            required: true
        },
        offset: {
            type: Number,
            required: true
        },
        blocSize: {
            type: Number,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
.trust-badge {
    font-size: 0.95rem;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
